import EditorCheckListCard from "../../../../components/checklist/EditorCheckListCard";

// Checklist card of the trailer: only shown when the header has a trailer.
const EditorTrailerCheckList = (props) => {
  const { headerData } = props;

  return (
    (headerData.trailer_id || headerData.data_trailer) && (
      <div className="row-start-start w-full flex-wrap gap-4">
        {/* check trailer */}
        <EditorCheckListCard
          {...props}
          wrapperClassName="elevated-card grow row-start-start !py-4 !px-4 md:grow-0 md:w-[50%]"
          listProblemData={undefined}
          title={"Trailer"}
          labelGrup={"trailer"}
        />
      </div>
    )
  );
};

export default EditorTrailerCheckList;
